import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePipe } from './image.pipe';
import { PhoneModalComponent } from './phone-modal/phone-modal.component';
import { PaymentModalComponent } from './payment-modal/payment-modal.component';
import { ConsentModalComponent } from './consent-modal/consent-modal.component';
import { TermsModalComponent } from './terms-modal/terms-modal.component';
import { PhoneFormComponent } from './phone-modal/phone-form/phone-form.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FooterComponent } from './footer/footer.component';
import { TopRightComponent } from './top-right/top-right.component';
import { ServicePickModalComponent } from './service-pick-modal/service-pick-modal.component';
import { PlacePickModalComponent } from './place-pick-modal/place-pick-modal.component';
import { DatePickModalComponent } from './date-pick-modal/date-pick-modal.component';
import { HoursPickModalComponent } from './hours-pick-modal/hours-pick-modal.component';
import { SearchByNameModalComponent } from './search-by-name-modal/search-by-name-modal.component';
import { OfferInfoModalComponent } from './offer-info-modal/offer-info-modal.component';
import { PaymentInfoModalComponent } from './payment-info-modal/payment-info-modal.component';
import { PartySizePopoverComponent } from './party-size-popover/party-size-popover.component';
import { EventBookingAttendeesManagementComponent } from './event-booking-attendees-management/event-booking-attendees-management.component';
import { AttendeesEditorComponent } from './attendees-editor/attendees-editor.component';
import { AttendeeFormModalComponent } from './event-booking-attendees-management/attendee-form-modal/attendee-form-modal.component';
import { PpPhonePipe } from './pipes/pp-phone.pipe';
import { EventCardComponent } from './event-card/event-card.component';
import { AngularPhoneUtilsLibModule } from 'angular-phone-utils-lib';
import { RouterModule } from '@angular/router';
import { IonIntlTelInputModule } from 'ion-intl-tel-input';
import { TranslateModule } from '@ngx-translate/core';
import { PpTranslatePipe } from './pipes/pp-translate.pipe';
import { MomentDatePipe } from '../core/pipes/moment-date.pipe';
import { ReactiveFormsModule } from '@angular/forms';

import { 
  MatDatepickerModule, 
  MatNativeDateModule
} from '@angular/material';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ImagePipe,
    PhoneModalComponent,
    PaymentModalComponent,
    TermsModalComponent,
    PhoneFormComponent,
    FooterComponent,
    TopRightComponent,
    ServicePickModalComponent,
    PlacePickModalComponent,
    DatePickModalComponent,
    HoursPickModalComponent,
    SearchByNameModalComponent,
    PpTranslatePipe,
    SearchByNameModalComponent,
    OfferInfoModalComponent,
    EventCardComponent,
    PaymentInfoModalComponent,
    ConsentModalComponent,
    PartySizePopoverComponent,
    MomentDatePipe,
    EventBookingAttendeesManagementComponent,
    AttendeesEditorComponent,
    PpPhonePipe,
    AttendeeFormModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatDatepickerModule,
    MatNativeDateModule,
    AngularPhoneUtilsLibModule,
    RouterModule,
    IonIntlTelInputModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    ImagePipe,
    PhoneModalComponent,
    PhoneFormComponent,
    FooterComponent,
    TopRightComponent,
    TranslateModule,
    PpTranslatePipe,
    OfferInfoModalComponent,
    ConsentModalComponent,
    EventCardComponent,
    PartySizePopoverComponent,
    MomentDatePipe,
    EventBookingAttendeesManagementComponent,
    PpPhonePipe,
    AttendeeFormModalComponent,
    AttendeesEditorComponent,
    IonicModule  
  ],
  entryComponents: [
    ServicePickModalComponent,
    PlacePickModalComponent,
    DatePickModalComponent,
    HoursPickModalComponent,
    SearchByNameModalComponent
  ]
})
export class SharedModule { }